<app-frontend-config></app-frontend-config>
<app-accessibility-widget></app-accessibility-widget>
<div class="main-layout">
  <div id="seccionGOV">
    <div class="gov-container">
      <a href="https://www.gov.co" target="_blank" title="Vínculo al sitio web del Gobierno de Colombia">
        <img id="logoGOV" alt="Escudo de Colombia y logo Gov.co" src="{{ assetsBase }}/images/logos/logo_gov_co.png" />
      </a>
    </div>
  </div>
  <div class="main-body">
    @if (isMobileView) {
      <button
        class="mobile-menu-trigger"
        type="button"
        (click)="openMobileMenu()"
        (keydown.enter)="openMobileMenu()"
        aria-label="Abrir menu"
      >
        <span class="hamburger-icon"></span>
      </button>
      <div
        class="mobile-menu-backdrop"
        [class.open]="isMobileMenuOpen"
        (click)="closeMobileMenu()"
        (keydown.enter)="closeMobileMenu()"
        tabindex="0"
        role="button"
        aria-label="Cerrar menu"
      ></div>
      <aside class="mobile-menu-panel" [class.open]="isMobileMenuOpen">
        <app-menu-left></app-menu-left>
      </aside>
    }

    <nz-layout>
      @if (!isMobileView) {
        <nz-sider [nzWidth]="isMenuCollapsed ? 80 : leftMenuWidth">
          <app-menu-left></app-menu-left>
        </nz-sider>
      }
      <nz-layout>
        <nz-content>
          <div class="page-wrapper">
            <div class="card">
              <!--
                BUG-275639 — `cdkScrollable` registra este contenedor en el ScrollDispatcher del
                CDK. Sin él, los paneles superpuestos (nz-select, date-picker, dropdown) se
                colocan una vez y se quedan quietos: al desplazarse por el formulario el campo
                sube y su lista de opciones se queda flotando donde estaba. Es el único elemento
                de la app con scroll propio (`overflow-y: auto`), así que basta con marcarlo.
              -->
              <div class="card-content" cdkScrollable>
                <router-outlet #outlet="outlet"></router-outlet>
                <!--
                  #278528 — El footer va DENTRO del contenedor con scroll: en este layout la página
                  no scrollea, solo `.card-content`, así que colgarlo por fuera lo dejaría fuera de
                  pantalla. Acá se alcanza bajando el contenido, igual que en la vista pública.
                -->
                <app-footer></app-footer>
              </div>
            </div>
          </div>
        </nz-content>
      </nz-layout>
    </nz-layout>
  </div>
</div>
